module.exports = __webpack_public_path__ + "static/media/1Asset-15Ads.a9981fe6.png";